(function (angular) {
    'use strict';

    angular.module('shared')
        /**
         * 
         */
        .directive("formGroupDropdown", ["$timeout", "utilService", function ($timeout, utilService) {
            // returns the Directive Definition Object
            return {
                require: '^form'/*, 'ngModel'*/,
                scope: {
                    model: "=",
                    name: "@",
                    label: "@",
                    required: "=",
                    values: "=",
                    showInvalid: "=",
                    itemLabel: "@",
                    itemDescription: "@",
                    itemValue: "@",
                    onChange: "&",
                    placeholder: "@",
                    filter: "@",
                    disabled: "="
                },
                templateUrl: "shared/directiveTemplates/form/directive.dropdown.html",
                link: function (scope, element, attrs, form) {

                    scope.search = {};

                    scope.form = form;
                    // default to name
                    scope.label = scope.label || scope.name;

                    scope.hasError = function () {
                        return utilService.formFieldHasError(scope.showInvalid, scope.form, scope.name);
                    }

                    function getSelectedText() {
                        if (scope.model) {
                            if (scope.itemLabel) {
                                var item = scope.values.find(function (value) {
                                    return (scope.itemValue ? value[scope.itemValue] : value) === scope.model;
                                });

                                if (item) {
                                    return scope.itemLabel ? item[scope.itemLabel] : item;
                                }
                            } else {
                                return scope.model;
                            }
                        } else {
                            return scope.placeholder;
                        }
                    }

                    scope.setValue = function (value) {

                        scope.model = scope.itemValue ? value[scope.itemValue] : value;

                        if (scope.onChange) {
                            $timeout(function () {
                                scope.onChange();
                            });
                        }
                    }

                    scope.searchCrit = function () {
                        return function (item) {

                            if (scope.search && scope.search.val) {
                                var string = scope.itemLabel ? item[scope.itemLabel] : item;

                                var index = string.indexOf(scope.search.val);

                                return index >= 0;;

                            } else {
                                return true;
                            }
                        };
                    }

                    scope.$watch('model', function (newVal, oldVal) {
                        scope.selectedText = getSelectedText();
                    });

                }
            };
        }]);
})(window.angular);
